import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";
import apiClient from "./apiClient";

export const fetchReportes = async () => {
  const res = await request(API_ROUTES.getReports);
  const json = await res.json();
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchTiposDatoReporte = async () => {
  const res = await request(`${API_ROUTES.getReports}/tipos-dato`);
  const json = await res.json();
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchComplementosReporte = async (idReporte) => {
  const res = await request(API_ROUTES.getComponentReport(idReporte));
  const json = await res.json();
  return {
    filtros: json.data?.filtros || [],
    columnas: json.data?.columnas || [],
  };
};

export const fetchOpcionesFiltroDependiente = async (filtroId, valorPadre) => {
  const res = await request(API_ROUTES.postOptionsDPReport, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      filtroId: Number(filtroId),
      valorPadre,
    }),
  });
  const json = await res.json();
  return Array.isArray(json.data) ? json.data : [];
};

export const ejecutarReporte = async (reporteId, filtros, extender) => {
  const res = await request(API_ROUTES.postReport, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      reporteId: Number(reporteId),
      filtros,
      extender,
      limite: extender,
    }),
  });
  const rs = await res.json();
  return rs;
};

export const fetchReporteFull = async (idReporte) => {
  const res = await request(`${API_ROUTES.getReports}/full?idReporte=${idReporte}`);
  const json = await res.json();
  return json.data;
};

export const guardarReporte = async (data) => {
  const res = await request(`${API_ROUTES.getReports}/guardar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  return json;
};

/**
 * Descarga el Reporte Resolución 202 como archivo TXT.
 * Usa apiClient (Axios) directamente con responseType: 'blob'
 * porque el shim clientsApi no soporta respuestas binarias.
 */
export const descargarReporte202 = async (fechaIni, fechaFin, empresa, sedes, eps = '', prestador = '999') => {
  try {
    const response = await apiClient({
      url: API_ROUTES.reporte202,
      method: 'POST',
      data: {
        fecha_ini: fechaIni,
        fecha_fin: fechaFin,
        empresa,
        sedes,
        eps,
        prestador,
      },
      responseType: 'blob',
      timeout: 300000, // 5 minutos para reportes pesados
    });

    const blob = new Blob([response.data], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    const contentDisposition = response.headers['content-disposition'];
    let filename = `Reporte202_${fechaIni}_${fechaFin}.txt`;
    if (contentDisposition && contentDisposition.includes("filename=")) {
      filename = contentDisposition.split("filename=")[1].replace(/"/g, "");
    }

    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // Con responseType: 'blob', el error viene como Blob — hay que leerlo como texto
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const json = JSON.parse(text);
        throw new Error(json.detail || json.message || text);
      } catch (parseErr) {
        if (parseErr.message !== text) throw parseErr;
        throw new Error(text);
      }
    }
    throw error;
  }
};

/**
 * Descarga el Reporte Resolución 2175 de 2015 como archivo TXT normativo.
 */
export const descargarReporte2175 = async (fechaIni, fechaFin, empresa, sedes) => {
  try {
    const response = await apiClient({
      url: API_ROUTES.reporte2175,
      method: 'POST',
      data: {
        fecha_ini: fechaIni,
        fecha_fin: fechaFin,
        empresa,
        sedes,
      },
      responseType: 'blob',
      timeout: 300000, // 5 minutos para reportes pesados
    });

    const blob = new Blob([response.data], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    const contentDisposition = response.headers['content-disposition'];
    let filename = `Reporte2175_${fechaIni}_${fechaFin}.txt`;
    if (contentDisposition && contentDisposition.includes("filename=")) {
      filename = contentDisposition.split("filename=")[1].replace(/"/g, "");
    }

    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const json = JSON.parse(text);
        throw new Error(json.detail || json.message || text);
      } catch (parseErr) {
        if (parseErr.message !== text) throw parseErr;
        throw new Error(text);
      }
    }
    throw error;
  }
};
